<template>
  <UiContainer class="not-found-view">
    <div class="not-found-view__content">
      <span class="not-found-view__icon" aria-hidden="true">?</span>
      <h1 class="not-found-view__code">404</h1>
      <h2 class="not-found-view__title">Страница не найдена</h2>
      <p class="not-found-view__text">
        К сожалению, запрашиваемая страница не существует или была перемещена.
      </p>
      <div class="not-found-view__actions">
        <UiButton to="/">На главную</UiButton>
        <UiButton variant="secondary" to="/catalog">Каталог товаров</UiButton>
      </div>
      <div class="not-found-view__links">
        <p class="not-found-view__links-title">Возможно, вас заинтересует:</p>
        <div class="not-found-view__links-wrap">
          <router-link to="/about" class="not-found-view__link">О компании</router-link>
          <router-link to="/contacts" class="not-found-view__link">Контакты</router-link>
          <router-link to="/delivery" class="not-found-view__link">Доставка</router-link>
        </div>
      </div>
    </div>
  </UiContainer>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import UiButton from '@/shared/ui/UiButton.vue'
import UiContainer from '@/shared/ui/UiContainer.vue'

onMounted(() => {
  document.title = 'Страница не найдена | ЛабАктив'
})
</script>

<style scoped>
.not-found-view {
  padding: 48px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.not-found-view__content {
  text-align: center;
  max-width: 480px;
}

.not-found-view__icon {
  font-size: 80px;
  line-height: 1;
  color: #cbd5e1;
  display: block;
  margin-bottom: 24px;
}

.not-found-view__code {
  margin: 0 0 16px;
  font-size: 48px;
  font-weight: 700;
  color: #0f172a;
}

.not-found-view__title {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 600;
}

.not-found-view__text {
  margin: 0 0 32px;
  font-size: 15px;
  color: #586578;
  line-height: 1.5;
}

.not-found-view__actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.not-found-view__links-title {
  margin: 0 0 12px;
  font-size: 14px;
  color: #586578;
}

.not-found-view__links-wrap {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.not-found-view__link {
  color: #0f172a;
  font-weight: 500;
  text-decoration: none;
}

.not-found-view__link:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .not-found-view__code {
    font-size: 36px;
  }

  .not-found-view__title {
    font-size: 18px;
  }
}
</style>
